import { cloneDeep, get, isArray, set } from 'lodash';
import { getLocalstorageToken } from '../../../../../context/AuthHelper';
import { PERSONALAUSHABEN_STARTUPPROJEKTE } from '../../../../../lib/constants/componentsPath';
import { IN_BEANTRAGTE_VORHABEN, KOSTEN_ARTEN, KOSTEN_POSITION } from '../../../../../lib/constants/constant';
import { getFieldNamefromDataPath, getIDFromResponseOption, groupKostenByPosition } from '../../../../../utils/helper';
import { calculateGesamtSumme, calculateProjektDauer, calculateProjektStartJahr } from '../commonFormulas';

import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
import KostenpositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
import LeistungsGruppeSchema from '../../../../../lib/paths/leistungsgruppe_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenpositionSchema.attributes;
const LG_P = LeistungsGruppeSchema.attributes;

export const startupProjektFormauls = (
	application: any,
	vonTag: number,
	vonMonat: string,
	bisTag: number,
	bisMonat: string,
	kostenKategories: any,
	leistungsgruppe: any
) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);

	let calcultedProjkJahr = calculateProjektStartJahr(appCopy, vonTag, vonMonat);
	let calcultedProjkdauer = calculateProjektDauer(appCopy, vonTag, vonMonat, bisTag, bisMonat);
	if (isArray(calcultedProjkJahr)) {
		for (let ele of calcultedProjkJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	if (isArray(calcultedProjkdauer)) {
		for (let ele of calcultedProjkdauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkJahr);
	result.push(...calcultedProjkdauer);

	if (get(appCopy, P.Allgemein_Projektdauerin_Jahren.path, 0) > 0) {
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
			let calculatedPersonalKosten: any[] = [];

			calculatedPersonalKosten = calculatePersonalKosten(appCopy, leistungsgruppe);
			result.push(...calculatedPersonalKosten);
			for (let ele of calculatedPersonalKosten) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
			let calculatedSachKosten: any[] = [];

			calculatedSachKosten = calculateSachKosten(appCopy);
			result.push(...calculatedSachKosten);
			for (let ele of calculatedSachKosten) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
			let calculatedEigenmittel: any[] = [];

			calculatedEigenmittel = calculateEigenmittel(appCopy);
			result.push(...calculatedEigenmittel);
			for (let ele of calculatedEigenmittel) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		// Berechnet die Förderquote auf Jarhen aufgeteilt für Antragsteller und jede Partner
		let calculatedFoerderQuote = calculateFoerderquoteProJahr(appCopy);
		result.push(...calculatedFoerderQuote);
		for (let ele of calculatedFoerderQuote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Jahrenaufteilung für Ausgaben, Einnahmen, Zuwendung und Förderquote
		let calculatedJahresaufteilung = calculateJahresAufteilung(appCopy);
		result.push(...calculatedJahresaufteilung);
		for (let ele of calculatedJahresaufteilung) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Gesamt Förderquote für Antragsteller und jede Partner
		let calculatedGesamtFoerderquote = calculateGesamtFoerderquote(appCopy);
		result.push(...calculatedGesamtFoerderquote);
		for (let ele of calculatedGesamtFoerderquote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		let calculatedGesamtSummeSkizze = calculateGesamtSumme(appCopy);
		if (isArray(calculatedGesamtSummeSkizze)) {
			for (let ele of calculatedGesamtSummeSkizze) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		result.push(...calculatedGesamtSummeSkizze);

		// END OF if ProjektJahren Dauern > 0
	}

	return result;
};

function calculatePersonalKosten(application: any, leistungsgruppe: any) {
	let result: any[] = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (let i = 0; i < allKostenPosition.length; i++) {
		const eachKostenPosition = allKostenPosition[i];

		if (get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path, '') === KOSTEN_ARTEN.Personalkosten) {
			const projektStartJahr = get(application, P.Allgemein_Projektstart_Jahr.path, '');
			const projektDauerJahr = get(application, P.Allgemein_Projektdauerin_Jahren.path, '');
			const KalkulationPersonalKosten = getTransformedPersonalKostenBlock(eachKostenPosition, leistungsgruppe, projektStartJahr, projektDauerJahr);

			result.push({ path: `${P.Foerderantrag_Kostenpositions.path}.${i}`, value: KalkulationPersonalKosten });
		}
	}

	return result;
}
function calculateSachKosten(application: any) {
	let result: any[] = [];
	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (let i = 0; i < allKostenPosition.length; i++) {
		const eachKostenPosition = allKostenPosition[i];

		if (get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Sachkosten) {
			const projektStartJahr = get(application, P.Allgemein_Projektstart_Jahr.path);
			const projektDauerJahr = get(application, P.Allgemein_Projektdauerin_Jahren.path);
			const KalkulationSachKosten = getTransformedSachKostenBlock(eachKostenPosition, projektStartJahr, projektDauerJahr);

			result.push({ path: `${P.Foerderantrag_Kostenpositions.path}.${i}`, value: KalkulationSachKosten });
		}
	}

	return result;
}
function calculateEigenmittel(application: any) {
	let result: any[] = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (let i = 0; i < allKostenPosition.length; i++) {
		const eachKostenPosition = allKostenPosition[i];

		if (get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel) {
			const projektStartJahr = get(application, P.Allgemein_Projektstart_Jahr.path, '');
			const projektDauerJahr = get(application, P.Allgemein_Projektdauerin_Jahren.path, '');
			const KalkulationEigenmittel = getTransformedEigenmittelBlock(eachKostenPosition, projektStartJahr, projektDauerJahr);

			result.push({ path: `${P.Foerderantrag_Kostenpositions.path}.${i}`, value: KalkulationEigenmittel });
		}
	}

	return result;
}
function calculateFoerderquoteProJahr(application: any) {
	let result: any = [];
	const allKostenPositionsARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const AntragstellerId = get(application, `${P.Antragstellende_Organisation.path}.id`);
	const allKostenpositionVonAntragsteller = allKostenPositionsARR.filter((ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === AntragstellerId);
	result.push({
		path: P.Antragstellende_Organisation_Foerderquote.path,
		value: calculateFoerderquoteData(allKostenpositionVonAntragsteller),
	});

	return result;
}
function calculateJahresAufteilung(application: any) {
	let result: any = [];
	const allKostenposition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	const calculatedJahreaufteilung = calculateFinancials(allKostenposition);
	result.push(
		{
			path: P.Allgemein_Geplante_Projektausgaben.path,
			value: get(calculatedJahreaufteilung, 'gesamtAusgaben'),
		},
		{
			path: P.Allgemein_Beantragte_Zuwendung.path,
			value: get(calculatedJahreaufteilung, 'gesamtZuwendung'),
		},
		{ path: P.Bewilligung_Jahresaufteilung.path, value: get(calculatedJahreaufteilung, 'Jahrenaufteilung') }
	);
	return result;
}
function calculateGesamtFoerderquote(application: any) {
	let result: any = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	// Förderquote für Antragsteller
	const allAusgabenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe'
	);

	const allEinnahmenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme'
	);

	const ausgabenGesamtAntragsteller = allAusgabenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmenGesamtAntragsteller = allEinnahmenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamtAntragsteller = ausgabenGesamtAntragsteller - einnahmenGesamtAntragsteller;
	const foerderQuoteAntragsteller = ausgabenGesamtAntragsteller !== 0 ? (zuwendungGesamtAntragsteller / ausgabenGesamtAntragsteller) * 100 : 0;

	result.push({
		path: P.Orga_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteAntragsteller) ? foerderQuoteAntragsteller.toFixed(2) : 0,
	});

	// FörderQuote unabhängig von Antragsteller oder Parter
	// Gesamt aussicht
	const allAusgaben_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe');
	const allEinnahme_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme');

	const ausgabenGesamt = allAusgaben_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmennGesamt = allEinnahme_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamt = ausgabenGesamt - einnahmennGesamt;
	const foerderQuoteGesamt = ausgabenGesamt !== 0 ? (zuwendungGesamt / ausgabenGesamt) * 100 : 0;

	result.push({
		path: P.Bewilligung_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteGesamt) ? foerderQuoteGesamt.toFixed(2) : 0,
	});
	return result;
}

/**************************************************************************************************************
 * ************************************ HELPER FUNCTIONS ******************************************************
 * ************************************************************************************************************
 */

function getTransformedPersonalKostenBlock(inputData: any, leistungsgruppe: any, projektJahrStart: any, projektDauer: number) {
	// Helper function to ensure the array length matches projektDauer, filling with empty objects if necessary
	// const ensureArrayLength = (array: any[], length: number, filler: any) => {
	// 	if (array.length > length) {
	// 		return array.slice(0, length);
	// 	} else {
	// 		const strapiFieldNameFuerJahr = getFieldNamefromDataPath(
	// 			KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Betrachtetes_Jahr.path,
	// 		);
	// 		const newArray = array.map((item, index) => ({
	// 			...item,
	// 			[strapiFieldNameFuerJahr]:
	// 				get(item, strapiFieldNameFuerJahr) !== undefined ? get(item, strapiFieldNameFuerJahr) : projektJahrStart + index,
	// 		}));
	// 		while (newArray.length < length) {
	// 			newArray.push({
	// 				...filler,
	// 				[strapiFieldNameFuerJahr]: projektJahrStart + newArray.length,
	// 			});
	// 		}
	// 		return newArray;
	// 	}
	// };
	// TODO: Diese muss noch überarbeitet werden. Wir wissen noch nicht, ob die Jahresaufteilung überhaupt hier erforderlich ist.
	// Daher ist hier erstmal die Funktion "ensureArrayLength" auskommentiert. Da in KostenPostion Pro Person nicht jedes Jahr teilnehmen musss.
	// Eine Person kann hier entweder nur ein einem Jahr beschäftigt sein, oder auch alle Jahren
	console.log({ projektDauer, projektJahrStart });

	// Helper function to calculate Zelle_2 for Allgemein_Kosten_Pro_Jahr
	const calculateAllgemeinKostenProJahr = (personalausgabenProjektjahrBlock1: any[]) => {
		return personalausgabenProjektjahrBlock1.map((item: any, i: number) => {
			const proJahrAusgabe =
				get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.Ausgaben) ? parseFloat(get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.Ausgaben, '0.0')) : 0;
			const result = {
				Zelle_1: get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.Jahr),
				Zelle_2: proJahrAusgabe,
			};
			if (get(inputData, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.${i}.id`))
				set(result, 'id', get(inputData, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.${i}.id`));
			return result;
		});
	};

	// Helper function to calculate Personalausgaben details
	const calculatePersonalausgabenStartUp = (personalausgaben: any[], positionBezeichnung: string) => {
		const calculatedStartUpProjektBlock = personalausgaben.map((item: any) => {
			const selectedLeistungsGruppeID = getIDFromResponseOption(get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.Leistungsgruppe));
			const selectedLeistungsGruppe_Obj = leistungsgruppe.find((ele: any) => get(ele, 'id') === selectedLeistungsGruppeID);
			const selectedVorhabenTaetig = get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.VorhabenTaetig);

			const maxEinsatzStundenErrechnet =
				1720 *
				((get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.WochenStunden, 0) / 40) *
					(get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.volleEinsatzmonaten) / 12));
			let MonatOrStundenSatz: number = 0;
			if (selectedVorhabenTaetig === IN_BEANTRAGTE_VORHABEN.ausschliesslich) {
				MonatOrStundenSatz = parseFloat(
					get(selectedLeistungsGruppe_Obj, LG_P.Allgemein_Personalkosten_Inkl_Arbeitsplatzkosten_pro_Monat.path, '0.0')
				);
			} else if (selectedVorhabenTaetig === IN_BEANTRAGTE_VORHABEN.nurTeilweise) {
				MonatOrStundenSatz = parseFloat(
					get(selectedLeistungsGruppe_Obj, LG_P.Allgemein_Personalkosten_Inkl_Arbeitsplatzkosten_pro_Stunde.path, '0.0')
				);
			}
			const ausgabe = MonatOrStundenSatz * parseFloat(get(item, PERSONALAUSHABEN_STARTUPPROJEKTE.AnzahlMonatOrStunden, '0.0'));

			const result = {
				...item,
				[PERSONALAUSHABEN_STARTUPPROJEKTE.NameDerPerson]: positionBezeichnung,
				[PERSONALAUSHABEN_STARTUPPROJEKTE.maxEinsatzStunden]: maxEinsatzStundenErrechnet,
				[PERSONALAUSHABEN_STARTUPPROJEKTE.MonatOrStundenSatz]: MonatOrStundenSatz,
				// [PERSONALAUSHABEN_STARTUPPROJEKTE.AnzahlMonatOrStunden]: projektJahrStart + index,
				[PERSONALAUSHABEN_STARTUPPROJEKTE.Ausgaben]: ausgabe,
			};
			if (item.id) set(result, 'id', item.id);
			return result;
		});

		return calculatedStartUpProjektBlock;
	};

	// Calculate the transformed data
	const calculatedPersonalausgaben = calculatePersonalausgabenStartUp(
		get(inputData, KP_P.Personalausgaben_Startup_Projekte.path, []),
		get(inputData, KP_P.Allgemein_Bezeichnung.path, '')
	);
	const calculatedAllgemeinKostenProJahr = calculateAllgemeinKostenProJahr(calculatedPersonalausgaben);

	return {
		...inputData,
		attributes: {
			...inputData.attributes,
			// [getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: ensureArrayLength(calculatedAllgemeinKostenProJahr, projektDauer, {
			// 	Zelle_2: '0.00',
			// }),
			// [getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.path)]: ensureArrayLength(calculatedPersonalausgaben, projektDauer, {
			// 	[getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_P_Leistungsgruppe.path)]: null,
			// }),
			[getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: calculatedAllgemeinKostenProJahr,
			[getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.path)]: calculatedPersonalausgaben,
			[getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path)]:
				calculateAllgemeinKostenProJehrGesamtSumme(calculatedAllgemeinKostenProJahr),
		},
	};
}
function getTransformedSachKostenBlock(data: any, projektJahrStart: any, projektDauer: number) {
	const kostenProJahr = get(data, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);

	// Ensure the array length matches projektDauer
	if (kostenProJahr.length < projektDauer) {
		// Add missing years with default values
		for (let i = kostenProJahr.length; i < projektDauer; i++) {
			kostenProJahr.push({
				Zelle_1: projektJahrStart + i,
				Zelle_2: null, // Default value
			});
		}
	} else if (kostenProJahr.length > projektDauer) {
		// Trim the array to match projektDauer
		kostenProJahr.splice(projektDauer);
	}

	// Update Zelle_1 and calculate Zelle_2 sum
	let sumZelle_2 = 0;
	kostenProJahr.forEach((item: any, index: number) => {
		item.Zelle_1 = projektJahrStart + index;
		sumZelle_2 += item.Zelle_2 ? parseFloat(item.Zelle_2) : 0; // Sum with 2 decimal places
	});

	// Update Allgemein_Geplante_Gesamtsumme
	data.attributes.Allgemein_Geplante_Gesamtsumme = sumZelle_2 ? sumZelle_2 : 0;

	// Ensure Zelle_2 values are 2 decimal numbers
	kostenProJahr.forEach((item: any) => {
		item.Zelle_2 = parseFloat(parseFloat(item.Zelle_2 || '0.0').toFixed(2));
	});

	return data;
}
function getTransformedEigenmittelBlock(data: any, projektJahrStart: any, projektDauer: number) {
	const kostenProJahr = get(data, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);

	// Ensure the array length matches projektDauer
	if (kostenProJahr.length < projektDauer) {
		// Add missing years with default values
		for (let i = kostenProJahr.length; i < projektDauer; i++) {
			kostenProJahr.push({
				Zelle_1: projektJahrStart + i,
				Zelle_2: null, // Default value
			});
		}
	} else if (kostenProJahr.length > projektDauer) {
		// Trim the array to match projektDauer
		kostenProJahr.splice(projektDauer);
	}

	// Update Zelle_1 and calculate Zelle_2 sum
	let sumZelle_2 = 0;
	kostenProJahr.forEach((item: any, index: number) => {
		item.Zelle_1 = projektJahrStart + index;
		sumZelle_2 += item.Zelle_2 ? parseFloat(item.Zelle_2) : 0; // Sum with 2 decimal places
	});

	// Update Allgemein_Geplante_Gesamtsumme
	data.attributes.Allgemein_Geplante_Gesamtsumme = sumZelle_2 ? sumZelle_2 : 0;

	// Ensure Zelle_2 values are 2 decimal numbers
	kostenProJahr.forEach((item: any) => {
		item.Zelle_2 = parseFloat(parseFloat(item.Zelle_2 || '0.0').toFixed(2));
	});

	return data;
}
function calculateFoerderquoteData(data: any[]) {
	// Extract all unique years from the data
	const years = Array.from(new Set(data.flatMap((item) => item.attributes.Allgemein_Kosten_Pro_Jahr.map((k: any) => k.Zelle_1))));

	// Calculate Foerderquote for each year
	const result = years.map((year) => {
		let sumAusgabe = 0;
		let sumEinnahme = 0;

		data.forEach((item) => {
			item.attributes.Allgemein_Kosten_Pro_Jahr.forEach((kosten: any) => {
				if (kosten.Zelle_1 === year) {
					const value = parseFloat(kosten.Zelle_2);
					if (!isNaN(value)) {
						if (item.attributes.Allgemein_Kostenposition === 'Ausgabe') {
							sumAusgabe += value;
						} else if (item.attributes.Allgemein_Kostenposition === 'Einnahme') {
							sumEinnahme += value;
						}
					}
				}
			});
		});

		const foerderquote = sumAusgabe !== 0 ? ((sumAusgabe - sumEinnahme) / sumAusgabe) * 100 : 0;

		return {
			Projektjahr: year,
			Foerderquote_403741: foerderquote.toFixed(2), // Round to two decimal places
		};
	});

	return result;
}
function calculateFinancials(data: any) {
	const result: any = {};

	let gesamtAusgaben = 0;
	let gesamtEinnahme = 0;

	data.forEach((item: any) => {
		const { Allgemein_Kostenposition, Allgemein_Kosten_Pro_Jahr } = item.attributes;

		Allgemein_Kosten_Pro_Jahr.forEach((yearlyCost: any) => {
			const year = yearlyCost.Zelle_1;
			const amount = parseFloat(yearlyCost.Zelle_2) || 0;

			if (!result[year]) {
				result[year] = {
					Projektjahr: year,
					Ausgaben: 0,
					Eigen_45_Und_Drittmittel: 0,
				};
			}

			if (Allgemein_Kostenposition === 'Ausgabe') {
				result[year].Ausgaben += amount;
				gesamtAusgaben += amount;
			} else if (Allgemein_Kostenposition === 'Einnahme') {
				result[year].Eigen_45_Und_Drittmittel += amount;
				gesamtEinnahme += amount;
			}
		});
	});

	const Jahrenaufteilung = Object.values(result).map((item: any) => {
		const { Ausgaben, Eigen_45_Und_Drittmittel } = item;
		const Zuwendung = (Ausgaben || 0) - (Eigen_45_Und_Drittmittel || 0);
		const Foerderquote_403741 = Ausgaben > 0 ? (Zuwendung / Ausgaben) * 100 : 0;

		return {
			...item,
			Ausgaben: Ausgaben.toFixed(2),
			Eigen_45_Und_Drittmittel: Eigen_45_Und_Drittmittel.toFixed(2),
			Zuwendung: Zuwendung.toFixed(2),
			Foerderquote_403741: Foerderquote_403741.toFixed(2),
		};
	});

	const gesamtZuwendung = gesamtAusgaben - gesamtEinnahme;
	const gesamtFoerderQuote = gesamtAusgaben > 0 ? (gesamtZuwendung / gesamtAusgaben) * 100 : 0;

	return {
		gesamtAusgaben: !isNaN(gesamtAusgaben) ? gesamtAusgaben.toFixed(2) : 0,
		gesamtEinnahme: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0,
		gesamtZuwendung: !isNaN(gesamtZuwendung) ? gesamtZuwendung.toFixed(2) : 0,
		gesamtFoerderQuote: !isNaN(gesamtFoerderQuote) ? gesamtFoerderQuote.toFixed(2) : 0,
		Jahrenaufteilung,
	};
}
export function calculateAllgemeinKostenProJehrGesamtSumme(dataArray: any) {
	const total = dataArray.reduce((sum: any, item: any) => {
		// Convert the Zelle_2 value to a number and add it to the sum
		return sum + parseFloat(get(item, 'Zelle_2', '0.0'));
	}, 0);

	// Return the total formatted to 2 decimal places
	return !isNaN(total) ? total.toFixed(2) : 0;
}
